import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../../libs'
import { Deposit } from '../../details'
import { RollbackDeposit } from './types'
import { transactionRequestStatus } from '../../../const'
import { depositMounted } from '../../edit/model'

export const mounted = createEvent()
export const unmounted = createEvent()
export const setRollback = createEvent<string>()
export const $rollback = restore<string>(setRollback, '')
export const submitRollback = createEvent<RollbackDeposit>()
export const rollbackTransactionRequest = fx<RollbackDeposit, Deposit>({
  method: 'PUT',
  url: `/transaction_request/`,
})

sample({
  clock: submitRollback,
  fn: ({ requestId, rejectReason }) => {
    return {
      query: {
        populate: JSON.stringify([
          'TransactionRequest.client',
          'TransactionRequest.wallets',
          'TransactionRequest.accounts',
          'Client.wallets',
          'Client.accounts',
        ]),
      },
      body: {
        requestId: requestId,
        status: transactionRequestStatus.rollback(),
        rejectReason: rejectReason,
      },
      url: `/transaction_request/${requestId}`,
    }
  },
  target: rollbackTransactionRequest,
})

// clear field on success

sample({
  clock: rollbackTransactionRequest.done,
  fn: () => ({}),
  target: [depositMounted],
})
